import { Default, Mobile } from '@components/common/Responsive'
import TranslationText from '@components/common/TranslationText'
import MobileOverview from '@components/product/v2/Mobile/Overview'
import ProductOverview from '@components/product/v2/Overview'
import SEO from '@components/SEO'
import { useResetProductMinQty } from '@hooks/useProduct'
import { Platform } from '@interfaces/platform'
import { imageToUrl } from '@utils/imageUtils'
import React, { useEffect } from 'react'
import CategoryBreadCrumb from '../CategoryBreadCrumb'
import ProductDetails from '../ProductDetails'
import SimilarProducts from '../SimilarProducts'
import './styles.css'

interface SingleProductProps {
  id: string
}

const SingleProduct: React.SFC<SingleProductProps | any> = props => {
  const { product } = props
  const reset = useResetProductMinQty()

  useEffect(
    () => {
      reset(product.id)
    },
    [product.id]
  )

  return (
    <div styleName="wrapper" data-product-platform={product.platform}>
      {/*<CategoryBreadCrumb categories={product.categories} platform={product.platform} />*/}

      <div className="mt-md-5">
        <ProductDetails {...props} />

        <div className="d-flex product-details-footer">
          {/* related product */}
          {props.enableSimilarProducts &&
            ((product.platform !== Platform.JD && product.id.includes('-')) ||
              product.platform === Platform.JD) && (
              <SimilarProducts
                id={product.id}
                platform={product.platform}
                supermarket={product.isSupermarket}
              />
            )}

          {/* Product Overview */}
          <section className="section-product-overview tw-w-full">
            <Mobile>
              <div className="tw-mt-12">
                <MobileOverview product={product} />
              </div>
            </Mobile>
            <Default>
              <ProductOverview product={product} />
            </Default>
          </section>
        </div>
      </div>

      {product.titles?.en ? (
        <SEO title={product.titles.en} image={imageToUrl(product.cover)} />
      ) : (
        <TranslationText texts={product.titles}>
          {text => <SEO title={text} image={imageToUrl(product.cover)} />}
        </TranslationText>
      )}
    </div>
  )
}

SingleProduct.defaultProps = {
  enableSimilarProducts: true,
}

export default SingleProduct
